import React from "react";
import {
    Box,
    Card,
    CardContent,
    Typography,
    Chip,
    Grid,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import theme from "../../theme";
import { TicketCategory, TicketDisplayStatus } from "../../common/const";
import moment from "moment";

const TicketListing = ({
    pathname,
    ticketData
}) => {
    const navigate = useNavigate();

    const getStatusColor = (status) => {
        switch (status) {
            case "OPEN":
                return {
                    bgcolor: "#155724",
                    color: "White",
                };
            case "IN_PROGRESS":
                return {
                    bgcolor: theme.palette.secondary.main,
                    color: theme.palette.primary.main,
                };
            case "CLOSED":
                return {
                    bgcolor: "red",
                    color: "white",
                };
            default:
                return {
                    bgcolor: "#E0E0E0",
                    color: "#424242",
                };
        }
    };

    const handleTicketClick = (ticketId) => {
        if (pathname !== '/support-help-desk') {
            navigate(`/ticket/${ticketId}`);
        } else {
            navigate(`/support-ticket/${ticketId}`);
        }
    };

    return (
        <Box sx={{ py: 2, bgcolor: "white", mt: 3, px: 2, borderRadius: 1 }}>
            {ticketData?.length > 0 ? (
            <Grid container spacing={1.5}>
                {ticketData?.map((ticket, index) => (
                    <Grid item xs={12} sm={6} md={3} key={index}>
                        <Card
                            sx={{
                                cursor: "pointer",
                                transition: "all 0.2s ease",
                                height: "100%",
                                border: "1px solid #0000001A",
                                borderRadius: "8px",
                                bgcolor: "#DBF0FF",
                                boxShadow: "0 0px 0px rgba(0,0,0,0.05)",
                            }}
                            onClick={() => handleTicketClick(ticket.ticket_id)}
                        >
                            <CardContent sx={{ p: 2 }}>
                                <Box    
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        mb: 1.5,
                                    }}
                                >
                                    <Typography
                                        variant="subtitle2"
                                        sx={{
                                            fontWeight: 600,
                                            color: "#000000",
                                            fontSize: "11px",
                                        }}
                                    >
                                        {ticket.ticket_number}
                                    </Typography>
                                    <Chip
                                        label={TicketDisplayStatus[ticket.status]}
                                        size="small"
                                        sx={{
                                            ...getStatusColor(ticket.status),
                                            fontWeight: 500,
                                            fontSize: "10px",
                                            height: "20px",
                                            borderRadius: "3px",
                                        }}
                                    />
                                </Box>

                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontWeight: 600,
                                        fontSize: "13px",
                                        color: "#000000",
                                        lineHeight: 1.4,
                                    }}
                                >
                                    {ticket.subject}
                                </Typography>

                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: "#888888",
                                        mb: 1.5,
                                        fontSize: "11px",
                                        lineHeight: 1.5,
                                        display: "-webkit-box",
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: "vertical",
                                        overflow: "hidden",
                                    }}
                                >
                                    {ticket.description}
                                </Typography>

                                <Box
                                    sx={{
                                        py: 0.3,
                                        borderRadius: 0.5,
                                        width: '60px',
                                        background: 'white',
                                        border: '1px solid #0000001A'
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: theme.palette.background.dark,
                                            fontSize: "11px",
                                            fontWeight: 500,
                                            textAlign: 'center',
                                        }}
                                    >
                                        {TicketCategory.find((a) => a.value === ticket.category)?.label}
                                    </Typography>
                                </Box>

                                <Typography
                                    variant="caption"
                                    sx={{
                                        color: "#AAAAAA",
                                        fontSize: "12px",
                                        display: "block",
                                        mt: 1,
                                    }}
                                >
                                    {moment(ticket?.last_updated).fromNow()}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
            ) : (
              <Typography color={theme.palette.background.dark} textAlign="center">No Ticket Found</Typography>
            )}
        </Box>
    );
};

export default TicketListing;